import { MouseEvent, useCallback, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@pelckmans/elementis/components/button';
import DropdownMenu from '@pelckmans/elementis/components/dropdown-menu';
import Options from '@pelckmans/elementis/icons/options';

export default function ActionMenuButton({ children }: { children: (handleToggle: () => void) => React.ReactNode }) {
  const menuId = useId();
  const { t } = useTranslation();

  const [buttonEl, setButtonEl] = useState<HTMLButtonElement | null>(null);

  const [open, setOpen] = useState(false);

  const handleToggle = useCallback((e?: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e?.preventDefault();

    setOpen(prev => !prev);
  }, []);

  function handleCollapse(e?: Event) {
    if (!open || buttonEl?.contains(e?.target as Node)) return;

    handleToggle();
  }

  return (
    <>
      <Button
        prominence="neutral"
        startIcon={<Options />}
        aria-label={t('PAGES.TOC_LEVEL.ACTION_MENU.BUTTON.A11Y_LABEL')}
        size="sm"
        onClick={handleToggle}
        ref={(el: HTMLButtonElement) => setButtonEl(el)}
        data-testid="action-menu-button"
      />
      {open && (
        <DropdownMenu
          actionEl={buttonEl}
          referenceEl={buttonEl}
          role="menu"
          menuProps={{
            ariaLabel: t('PAGES.TOC_LEVEL.ACTION_MENU.A11Y_LABEL'),
            id: menuId,
          }}
          selectableByEnter
          onCollapse={handleCollapse}
          grow
          flip
        >
          {children(handleToggle)}
        </DropdownMenu>
      )}
    </>
  );
}
